import { api } from '../../services/api'

export const getMarkets = () => {
	return (dispatch) => {
		dispatch({ type: 'GET_MARKETS' })

		return api
			.get('/markets')
			.then((response) => {
				dispatch({ type: 'GET_MARKETS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_MARKETS_FAIL' })
			})
	}
}
